<template>
    <div class="home-container">
        <!-- electionTypeButtonsArray -->
        <section class="d-flex align-items-center gap-3">
            <primaryButtonComponent v-for="(data, i) of finalResultTypeButtonsArray" :mode="data.mode" @click="finalResultTypeButtonsHandler('finalResultType', data.routeSetValue, this.finalResultTypeButtonsArray)" buttonType="button" paddingX="14px" paddingY="8px" class="before-large-text font-weight-600" buttonWidth="max-content">
                <template v-slot:content>
                    <p>{{ data.content }}</p>
                </template>
            </primaryButtonComponent>
        </section>
        <section class="d-flex align-items-center gap-3">
            <primaryButtonComponent v-for="(data, i) of electionTypeButtonsArray" :mode="data.mode" @click="finalResultTypeButtonsHandler('electionType', data.routeSetValue, this.electionTypeButtonsArray)" buttonType="button" paddingX="14px" paddingY="8px" class="before-large-text font-weight-600" buttonWidth="max-content">
                <template v-slot:content>
                    <p>{{ data.content }}</p>
                </template>
            </primaryButtonComponent>
        </section>
        <section class="final-results-common-statistics-wrapper">
            <div class="final-results-total-statistics-wrapper border-radius-20 d-flex flex-column align-items-stretch gap-2 p-3 p-xl-4">
                <div class="d-flex align-items-center justify-content-between">
                    <h5 class="extra-large-text font-weight-600 extra-black-color text-start">საბოლოო შედეგები</h5>
                    <h5 class="extra-large-text font-weight-600 extra-black-color text-start">დათვლილი უბნები:<span>{{ ` ${finalTotalResultsInformation[0]?.district_count?finalTotalResultsInformation[0]?.district_count:0}` }}</span></h5>
                </div>
                <div class="d-flex align-items-center gap-2 w-100">
                    <div class="d-flex flex-column align-items-start p-3 gap-2 w-100 border-radius-10" style="background-color: var(--main-background-color);">
                        <h6 class="large-text font-weight-600 extra-black-color text-start">ამომრჩევლის აქტივობა</h6>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <p class="after-extra-large-text font-weight-600 extra-green-color text-start">{{ finalTotalResultsInformation[0]?.attendance?finalTotalResultsInformation[0].attendance:0 }}</p>
                            <p class="px-3 py-2 extra-large-text font-weight-600 extra-green-color border-radius-10" style="background-color: var(--secondary-background-color);">
                                {{ `${finalTotalResultsInformation[0]?.sum_count?(finalTotalResultsInformation[0].attendance / finalTotalResultsInformation[0].sum_count * 100).toFixed(2):0}%` }}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-start p-3 gap-2 w-100 border-radius-10" style="background-color: var(--main-background-color);">
                        <h6 class="large-text font-weight-600 extra-black-color text-start">გაბათილებული ბიულეტენები</h6>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <p class="after-extra-large-text font-weight-600 extra-red-color text-start">{{ finalTotalResultsInformation[0]?.rejected?finalTotalResultsInformation[0].rejected:0 }}</p>
                            <p class="px-3 py-2 extra-large-text font-weight-600 extra-red-color border-radius-10" style="background-color: var(--secondary-background-color);">
                                {{ `${finalTotalResultsInformation[0]?.attendance?(finalTotalResultsInformation[0].rejected / finalTotalResultsInformation[0].attendance * 100).toFixed(2):0}%` }}
                            </p>
                        </div>
                    </div>
                </div>
                <form @submit.prevent="submitTotalFinalResults" class="final-results-total-filters-wrapper d-flex flex-wrap align-items-center justify-content-end gap-2">
                    <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                    <Multiselect ref="districtID" v-model="finalTotalResultsFiltersInfoObj.cityID" :options="this.finalTotalResultsMultiselectsArray[0].options" :mode="this.finalTotalResultsMultiselectsArray[0].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 1, true, true, finalTotalResultsMultiselectsArray, finalTotalResultsFiltersInfoObj)" @deselect="() => blockNextMultiselects(1, finalTotalResultsMultiselectsArray, finalTotalResultsFiltersInfoObj)" @clear="() => blockNextMultiselects(1, finalTotalResultsMultiselectsArray, finalTotalResultsFiltersInfoObj)"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.finalTotalResultsMultiselectsArray[0].placeholder" :disabled="this.finalTotalResultsMultiselectsArray[0].isDisabled" insert/>
                    
                    <Multiselect ref="districtID" v-model="finalTotalResultsFiltersInfoObj.regionID" :options="this.finalTotalResultsMultiselectsArray[1].options" :mode="this.finalTotalResultsMultiselectsArray[1].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, finalTotalResultsMultiselectsArray, finalTotalResultsFiltersInfoObj)" @deselect="() => blockNextMultiselects(2, finalTotalResultsMultiselectsArray, finalTotalResultsFiltersInfoObj)" @clear="() => blockNextMultiselects(2, finalTotalResultsMultiselectsArray, finalTotalResultsFiltersInfoObj)"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.finalTotalResultsMultiselectsArray[1].placeholder" :disabled="this.finalTotalResultsMultiselectsArray[1].isDisabled" insert/>
                    
                    <Multiselect ref="districtID" v-model="finalTotalResultsFiltersInfoObj.districtID" :options="this.finalTotalResultsMultiselectsArray[2].options" :mode="this.finalTotalResultsMultiselectsArray[2].mode"
                        :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                        :hideSelected="true" locale="ge"
                        class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.finalTotalResultsMultiselectsArray[2].placeholder" :disabled="this.finalTotalResultsMultiselectsArray[2].isDisabled" insert/>
                </form>
                <div class="d-flex flex-column align-items-start w-100 gap-3">
                <h5 class="extra-large-text font-weight-600">პარტიების ჭრილში</h5>
                <ul class="d-flex flex-column align-items-start w-100 gap-2">
                    <template v-for="(data, i) of finalTotalResultsInformation.slice(0, 6)">
                        <li class="w-100">
                            <customProgressLine commonBackgroundColor="green" progressLineHeight="25px" :progressLineFillLevel="`${(Number(data.attendance) - Number(data.rejected))?(Number(data.amount) / (Number(data.attendance) - Number(data.rejected)) *100).toFixed(2):0}%`">
                                <template v-slot:main-specifier>
                                    <h6 class="extra-large-text font-weight-600 border-radius-10 d-flex align-items-center justify-content-center" style="background-color: green; height: 100%; aspect-ratio: 1 / 1; min-width: 40px; color: var(--secondary-background-color)">
                                        {{ data.party_number }}
                                    </h6>
                                </template>
                                <template v-slot:title>
                                    <h6 class="light-text font-weight-500 d-flex align-items-center justify-content-center text-start">
                                        {{ data.party }}
                                    </h6>
                                </template>
                                <template v-slot:inner-left-info>
                                    <h3 class="light-text extra-black-color font-weight-600">
                                        {{ `${(Number(data.attendance) - Number(data.rejected))?(Number(data.amount) / (Number(data.attendance) - Number(data.rejected)) *100).toFixed(2):0}%` }}
                                    </h3>
                                </template>
                                <template v-slot:inner-right-info>
                                    <h3 class="light-text font-weight-600 extra-black-color">{{ `${data.amount} ხმა` }}</h3>
                                </template>
                            </customProgressLine>
                        </li>
                    </template>
                    <li @click="activateModalMode('finalTotalResultsFullList', true)" class="w-100" v-if="finalTotalResultsInformation.length > 6">
                        <customProgressLine commonBackgroundColor="green" progressLineHeight="25px">
                            <template v-slot:main-specifier>
                                <h6 class="cursor-pointer extra-large-text border-radius-10 font-weight-600 d-flex align-items-center justify-content-center" style="background-color: green; height: 100%; aspect-ratio: 1 / 1; min-width: 50px; color: var(--secondary-background-color)">
                                    სხვა
                                </h6>
                            </template>
                            <template v-slot:title>
                                <h6 class="light-text font-weight-500 d-flex align-items-center justify-content-center text-start">
                                    დეტალურად ნახვა
                                </h6>
                            </template>
                            <template v-slot:inner-left-info>
                                <h3 class="light-text extra-black-color font-weight-600">
                                </h3>
                            </template>
                            <template v-slot:inner-right-info>
                                <h3 class="light-text font-weight-600 extra-black-color"></h3>
                            </template>
                        </customProgressLine>
                    </li>
                </ul>
            </div>
            </div>
            <div class="final-results-detailed-statistics-wrapper border-radius-20 d-flex flex-column align-items-stretch gap-2 p-3 p-xl-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center justify-content-start gap-4 extra-black-color">
                        <h4 class="extra-large-text font-weight-600">აქტივობა</h4>
                        <div ref="detailedFinalResultsInfoAll" class="d-flex align-items-center gap-2">
                            <primaryButtonComponent v-for="(data, i) of detailedFinalResultsInfoAllgetterButtonsArray" :mode="data.mode" @click="detailedFinalResultsGetterButtonsHandler(i)" buttonType="button" paddingX="14px" paddingY="8px" class="before-large-text font-weight-600" buttonWidth="max-content">
                                <template v-slot:content>
                                    <p>{{ data.content }}</p>
                                </template>
                            </primaryButtonComponent>
                        </div>
                    </div>
                    <h4 class="extra-large-text font-weight-600">დათვლილი უბნები: <span> {{ detailedFinalResultsCountedDistricts }}</span></h4>
                </div>
                <div class="d-flex flex-column align-items-start w-100">
                    <ul class="d-flex flex-column align-items-start gap-2 w-100 font-weight-600">
                        <li class="d-flex align-items-center justify-content-start gap-4 w-100">
                            <h3 class="large-text extra-black-color text-start" style="min-width: 100px;">საქართველო</h3>
                            <customProgressLine commonBackgroundColor="#1FD286" :progressLineFillLevel="`${detailedFinalResultsInformationForCapitalAndCountry.georgia?detailedFinalResultsInformationForCapitalAndCountry.georgia:0}%`" :showTitle="false" :showRightInfo="false" :showMainSpecifier="false" progressLineHeight="15px" progressLineBackColor="transparent">
                                <template v-slot:inner-left-info>
                                    <h3 class="before-extra-large-text extra-black-color extra-green-color">
                                        {{ `${detailedFinalResultsInformationForCapitalAndCountry.georgia?detailedFinalResultsInformationForCapitalAndCountry.georgia:0}%` }}
                                    </h3>
                                </template>
                            </customProgressLine>
                        </li>
                        <li class="d-flex align-items-center justify-content-start gap-4 w-100">
                            <h3 class="large-text extra-black-color text-start" style="min-width: 100px;">თბილისი</h3>
                            <customProgressLine commonBackgroundColor="#1E5EFF" :progressLineFillLevel="`${detailedFinalResultsInformationForCapitalAndCountry.tbilisi?detailedFinalResultsInformationForCapitalAndCountry.tbilisi:0}%`" :showTitle="false" :showRightInfo="false" :showMainSpecifier="false" progressLineHeight="15px" progressLineBackColor="transparent">
                                <template v-slot:inner-left-info>
                                    <h3 class="large-text extra-blue-color">
                                        {{ `${detailedFinalResultsInformationForCapitalAndCountry.tbilisi?detailedFinalResultsInformationForCapitalAndCountry.tbilisi:0}%` }}
                                    </h3>
                                </template>
                            </customProgressLine>
                        </li>
                    </ul>
                </div>
                <div class="common-table-container common-scrollbar mt-2 p-0 rounded-0 d-flex flex-column justify-content-between" style="height: 100%">
                    <table class="common-tablee">
                        <thead>
                            <tr>
                                <th class="light-text light-blue-color">
                                    დასახელება
                                </th>
                                <th v-for="(item, i) of detailedFinalResultsOrderByButtonsArray" @click="handleDetailedFinalResultsAscDesc(i)" class="light-text light-blue-color">
                                    <ascDescBlock :isActive="item.isActive" :activeMode="item.activeMode">
                                        <template v-slot:text-content>
                                            {{ item.content }}
                                        </template>
                                    </ascDescBlock>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, i) of detailedFinalResultsInformation"  class="light-black-color light-text">
                                <td v-if="data.district"><p>{{ data.district }}</p></td>
                                <td v-else><p>{{ data.region }}</p></td>
                                <td>
                                    <div class="d-flex justify-content-center w-100">
                                        <p style="text-align: center" class="w-100">
                                            <span class="font-weight-600">{{ `${data.attendance?data.attendance:0}/` }}</span>
                                            {{ `${data.sum_count?data.sum_count:0}` }}
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex justify-content-center w-100">
                                        <p style="text-align: center" class="w-100">
                                            <span class="font-weight-600 extra-green-color">{{ `${data.activityPercentage}%` }}</span>
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="d-flex align-items-center justify-content-between">
                        <vue-awesome-paginate
                            :total-items="detailedFinalResultsPagingInfo.total"
                            :items-per-page="detailedFinalResultsPagingInfo.limit"
                            :max-pages-shown="2"
                            v-model="detailedFinalResultsPagingInfo.offset"

                            :hide-prev-next-when-ends="true"
                            :hide-prev-next="true"
                            :show-breakpoint-buttons="true"
                            :disable-breakpoint-buttons="false"

                            @click="finalResultsPaginationClickHandler"
                            class="my-2 align-self-center"
                        />
                        <excelFileDownloadComponent @igniteDownload="detailedActivityDownloadIgnition" @abortDownload="detailedActivityAbortDownload" :excelFileName="this.filteringPagingInfo.finalResultType==1?'detailed_activity_by_machine':'detailed_activity_by_document'" :namesArray="['აქტივობა ოლქებში', 'აქტივობა უბნებში']" :jsonToExcelArray="detailedActivityJsonToExcelArray" :downloadInAction="detailedActivityDownloadInAction" :canAbortDownload="true"/>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="final-idle-results w-100 border-radius-20 d-flex flex-column align-items-stretch gap-4 p-3 p-xl-4">
                <div class="d-flex align-items-center justify-content-between gap-3">
                    <h3 class="extra-large-text">შედეგები უბნების მიხედვით</h3>
                    <h3 class="extra-large-text">დათვლილი უბნები: <span>{{ singleFinalResultsCountedDistricts }}</span></h3>
                </div>
                <form class="search-container-form d-flex align-items-center justify-content-between" @submit.prevent="submitFinalSingleResultsFilters">
                    <fieldset class="filters-wrapper">
                        <Multiselect ref="districtID" v-model="FinalSinglefiltersInfoObj.cityID" :options="this.finalSingleMultiselectArray[0].options" :mode="this.finalSingleMultiselectArray[0].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 1, true, true, finalSingleMultiselectArray, FinalSinglefiltersInfoObj)" @deselect="() => blockNextMultiselects(1, finalSingleMultiselectArray, FinalSinglefiltersInfoObj)" @clear="() => blockNextMultiselects(1, finalSingleMultiselectArray, FinalSinglefiltersInfoObj)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.finalSingleMultiselectArray[0].placeholder" :disabled="this.finalSingleMultiselectArray[0].isDisabled" insert/>
                        
                        <Multiselect ref="districtID" v-model="FinalSinglefiltersInfoObj.regionID" :options="this.finalSingleMultiselectArray[1].options" :mode="this.finalSingleMultiselectArray[1].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" @select="(value, option) => allowNextMultiselect(value, 2, true, true, finalSingleMultiselectArray, FinalSinglefiltersInfoObj)" @deselect="() => blockNextMultiselects(2, finalSingleMultiselectArray, FinalSinglefiltersInfoObj)" @clear="() => blockNextMultiselects(2, finalSingleMultiselectArray, FinalSinglefiltersInfoObj)"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.finalSingleMultiselectArray[1].placeholder" :disabled="this.finalSingleMultiselectArray[1].isDisabled" insert/>
                        
                        <Multiselect ref="districtID" v-model="FinalSinglefiltersInfoObj.districtID" :options="this.finalSingleMultiselectArray[2].options" :mode="this.finalSingleMultiselectArray[2].mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge"
                            class="extra-light-text light-blue-color" autocomplete="off" :placeholder="this.finalSingleMultiselectArray[2].placeholder" :disabled="this.finalSingleMultiselectArray[2].isDisabled" insert/>

                        <button @click="resetFilters" type="button" class="extra-light-text extra-red-color ms-2" style="font-weight: 600; background-color: transparent;">reset</button>
                        <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                    </fieldset>
                    <excelFileDownloadComponent @igniteDownload="singleFinalResultsDownloadIgnition" @abortDownload="singleFinalResultsAbortDownload" :excelFileName="this.filteringPagingInfo.finalResultType==1?'election_results_by_machine':'election_results_by_document'" :namesArray="['არჩევნების შედეგები']" :jsonToExcelArray="singleFinalResultsJsonToExcelArray" :downloadInAction="singleFinalResultsDownloadInAction" :canAbortDownload="true"/>

                </form>
                <div class="d-flex flex-column justify-content-between gap-2" style="height: 100%">
                    <div class="cards-common-grid-wrapper">
                        <template v-for="(item, i) of singleFinalResultsInformation">
                            <commonCardAccordion v-if="!isAccordionOpened || indexOfOpenedAccordion == i" backgroundColor="#F5F7FA" :allowStaticClose="true" @openAccordionOnIndex="openAccordionOnIndex(i, (item?.attendance)?item.attendance:0, (item?.rejected)?item?.rejected:0, item)" :closeTrigger="accordionCardCloseTrigger" @closeAccordionOnIndex="closeAccordionOnIndex(i)">
                                <template v-slot:left>
                                    <div class="d-flex flex-column align-items-start" style="width: max-content;">
                                        <p class="extra-light-text light-blue-color">რეგიონი</p>
                                        <p class="light-text font-weight-600 light-black-color">{{ item.region.region }}</p>
                                        <div v-if="item.parties[0]?.election_result?.created_by?.name" class="d-flex align-items-center column-gap-1">
                                            <p class="extra-light-text font-weight-500 light-blue-color">ავტორი: </p>
                                            <p class="extra-light-text light-blue-color" style="width: max-content;">{{ `${item.parties[0]?.election_result?.created_by?.name} ${item.parties[0]?.election_result?.created_by?.surename} (${item.parties[0]?.election_result?.created_by?.phone})` }}</p>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:middle>
                                    <ul class="d-flex align-items-center gap-5 justify-content-between w-100 px-5">
                                        <li class="d-flex flex-column align-items-center gap-1">
                                            <p class="extra-light-text light-blue-color">უბანი</p>
                                            <p class="light-text font-weight-600 light-black-color">{{ item.district }}</p>
                                        </li>
                                        <li class="d-flex flex-column align-items-center gap-1">
                                            <p class="extra-light-text light-blue-color">დრო</p>
                                            <p class="light-text font-weight-600 light-black-color">{{ item?.parties[0]?.election_result?.input_date?item.parties[0].election_result.input_date.slice(-8):"---------" }}</p>
                                        </li>
                                        <li class="d-flex flex-column align-items-center gap-1">
                                            <p class="extra-light-text extra-gray-color">დასწრება</p>
                                            <p class="light-text font-weight-600 light-black-color">
                                                {{ (item?.attendance)?item.attendance:0 }}
                                                <span v-if="item?.attendance" class="ms-1 extra-green-color">
                                                    {{ `${(item?.sum_counts?.sum_count)?(item.attendance / item.sum_counts.sum_count * 100).toFixed(2): 0}%` }}
                                                </span>
                                            </p>
                                        </li>
                                        <li class="d-flex flex-column align-items-center gap-1">
                                            <p class="extra-light-text extra-gray-color">გაბათილებული</p>
                                            <p class="light-text font-weight-600 light-black-color">
                                                {{ (item?.rejected)?(item.rejected):0 }}
                                                <span v-if="item?.rejected" class="ms-1 extra-red-color">
                                                    {{ `${item.attendance?(item.rejected / item.attendance * 100).toFixed(2): 0}%` }}
                                                </span>
                                            </p>
                                        </li>
                                        <li class="d-flex flex-column align-items-center gap-1">
                                            <p class="extra-light-text light-blue-color">ფოტო</p>
                                            <p class="light-text font-weight-600 light-black-color">{{ item?.media_files?.length > 0?"კი":"არა" }}</p>
                                        </li>
                                    </ul>
                                </template>
                                <template v-slot:additionalInfo>
                                    <div class="d-flex flex-column gap-3 align-items-start">
                                        <article class="d-flex align-items-center justify-content-start w-100 flex-wrap gap-3">
                                            <ul v-if="item?.media_files?.length > 4" class="d-flex align-items-center justify-content-start extra-light-text flex-wrap row-gap-1 column-gap-2">
                                                <template v-for="(fileObj, i) of item?.media_files">
                                                    <li v-if="fileObj.result_file" @click="activateModalMode('photo', true), setElectionPhoto(`data:image/jpeg;base64,${fileObj.result_file}`, item.district)" class="problem-images-wrapper d-flex align-items-center gap-2">
                                                        <img :src="`data:image/jpeg;base64,${fileObj.result_file}`" alt="image" class="cursor-pointer">
                                                    </li>
                                                </template>
                                            </ul>
                                            <ul v-else class="d-flex align-items-center justify-content-start extra-light-text flex-wrap gap-1 gap-xl-2">
                                                <template v-for="(justElement, i) of [0, 1, 2, 3]">
                                                    <li v-if="item?.media_files[i]" class="problem-images-wrapper d-flex align-items-center gap-2">
                                                        <img :src="`data:image/jpeg;base64,${item?.media_files[i].result_file}`" @click="activateModalMode('photo', true), setElectionPhoto(`data:image/jpeg;base64,${item?.media_files[i].result_file}`, item.district)" alt="image" class="cursor-pointer">
                                                    </li>
                                                    <li v-else class="problem-images-wrapper d-flex align-items-center gap-2">
                                                        <button buttonType="button" class="image-alternative d-flex align-items-center justify-content-center large text border-radius-10" style="background-color: var(--secondary-background-color);">empty</button>
                                                    </li>
                                                </template>
                                            </ul>
                                        </article>
                                        <article class="d-flex align-items-center justify-content-between w-100 flex-wrap gap-3">
                                            <form ref="singleFinalResultsChangeForm" @submit.prevent="addChangesToSingleFinalResult">
                                                <ul class="d-flex flex-row align-items-center justify-content-start extra-light-text light-blue-color flex-wrap gap-3 gap-xl-4 mt-3">
                                                    <li v-if="currentlySelectedDistrictsAttendance != null" class="d-flex flex-column align-items-start text-start gap-2">
                                                        <label for="attendance" class="light-black-color text-start light-text font-weight-600">დასწრება</label>
                                                        <input v-model="currentlySelectedDistrictsAttendance" name="attendance" title="დასწრება" id="attendance" type="number" class="blue-part-input p-2 large-text" placeholder="დასწრება"/>
                                                    </li>
                                                    <li v-if="currentlySelectedDistrictsRejected != null" class="d-flex flex-column align-items-start text-start gap-2">
                                                        <label for="rejected" class="light-black-color text-start light-text font-weight-600">გაბათილებული</label>
                                                        <input v-model="currentlySelectedDistrictsRejected" name="rejected" title="გაბათილებული ბიულეტენები" id="rejected" type="number" class="blue-part-input p-2 large-text" placeholder="გაბათილებული"/>
                                                    </li>
                                                    <li class="d-flex flex-column align-items-start text-start gap-2">
                                                        <label for="evidenceImage" class="light-black-color text-start light-text font-weight-600">ატვირთეთ ფოტო</label>
                                                        <input ref="evidenceImage" type="file" name="evidenceImage" id="evidenceImage" accept="image/jpeg" class="cursor-pointer blue-part-input light-text p-2" style="width: min-content">
                                                    </li>
                                                    <li class="d-flex align-items-center gap-2">
                                                        <secondaryButton :disabled="isSending" buttonWidth="min-content" paddingX="8px" paddingY="5px" buttonType="submit" class="large-text mt-4">
                                                            <template v-slot:content>
                                                                დადასტურება
                                                            </template>
                                                        </secondaryButton>
                                                    </li>
                                                </ul>
                                            </form>
                                        </article>
                                        <article class="w-100">
                                            <ul class="single-final-results-parties-grid-wrapper w-100">
                                                <template v-for="(data, i) of item.parties">
                                                    <li class="d-flex flex-column align-items-start row-gap-1">
                                                        <customProgressLine commonBackgroundColor="green" progressLineBackColor="#FFFFFF" progressLineHeight="20px" :progressLineFillLevel="`${(data?.election_result?.attendance - data?.election_result?.rejected)?(data.election_result.amount / (data.election_result.attendance - data.election_result.rejected) * 100).toFixed(2):0}%`">
                                                            <template v-slot:main-specifier>
                                                                <h6 class="light-text font-weight-600 border-radius-10 d-flex align-items-center justify-content-center" style="background-color: green; height: 100%; aspect-ratio: 1 / 1; min-width: 20px; color: var(--secondary-background-color)">
                                                                    {{data.party_number}}
                                                                </h6>
                                                            </template>
                                                            <template v-slot:title>
                                                                <h6 class="party-name extra-light-text font-weight-600 d-flex align-items-center justify-content-center text-start">
                                                                    {{ `${data.party_name.slice(0, 35)}${data.party_name.length > 30?'...':''}` }}
                                                                </h6>
                                                            </template>
                                                            <template v-slot:inner-left-info>
                                                                <h3 class="light-text extra-black-color font-weight-600">
                                                                    {{ `${(data?.election_result?.attendance - data?.election_result?.rejected)?(data.election_result.amount / (data.election_result.attendance - data.election_result.rejected) * 100).toFixed(2):0}%` }}
                                                                </h3>
                                                            </template>
                                                            <template v-slot:inner-right-info>
                                                                <div class="d-flex justify-content-end align-items-center" style="background: var(--main-background-color); width: 40%; max-width: 90px; border-radius: 4px; height: 12px;">
                                                                    <input v-model="electionPartiesResultsVmodels[data.partyID]" @input="setChangedPartyAmount(electionPartiesResultsVmodels[data.partyID], data)" :name="`votesNumber${item.lat}${item.lng}${data.partyID}`" title="ხმების რაოდენობა" :id="`votesNumber${item.lat}${item.lng}${data.partyID}`" type="number" class="text-end" style="width: 100%; height: 12px; border-radius: 4px; background-color: var(--main-background-color)">
                                                                    <span>ხმა</span>
                                                                </div>
                                                            </template>
                                                        </customProgressLine>
                                                        
                                                    </li>
                                                </template>
                                            </ul>
                                        </article>
                                    </div>
                                </template>
                            </commonCardAccordion>
                        </template>
                    </div>
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <vue-awesome-paginate
                            :total-items="singleFinalResultsPagingInfo.total"
                            :items-per-page="singleFinalResultsPagingInfo.limit"
                            :max-pages-shown="2"
                            v-model="singleFinalResultsPagingInfo.offset"
                            :hide-prev-next-when-ends="false"
                            :show-breakpoint-buttons="true"
                            @click="singlefinalResultsPaginationClickHandler"
                            class="my-2 align-self-center"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
    <primaryModalComponent :showModal="showModal" maxHeight="781px" maxWidth="846px" @closeModal="triggerModal">
        <template v-slot:modal-content>
            <div class="d-flex flex-column align-items-stretch gap-4">
                <h5 class="extra-large-text">
                    {{ `${modalTitle}` }}
                </h5>
                <ul v-if="modalMode == 'finalTotalResultsFullList'" class="d-flex flex-column align-items-start w-100 gap-2">
                    <template v-for="(data, i) of finalTotalResultsInformation">
                        <li class="w-100">
                            <customProgressLine commonBackgroundColor="green" progressLineHeight="25px" :progressLineFillLevel="`${(Number(data.attendance) - Number(data.rejected))?(Number(data.amount) / (Number(data.attendance) - Number(data.rejected)) *100).toFixed(2):0}%`">
                                <template v-slot:main-specifier>
                                    <h6 class="extra-large-text font-weight-600 border-radius-10 d-flex align-items-center justify-content-center" style="background-color: green; height: 100%; aspect-ratio: 1 / 1; min-width: 40px; color: var(--secondary-background-color)">
                                        {{data.party_number}}
                                    </h6>
                                </template>
                                <template v-slot:title>
                                    <h6 class="light-text font-weight-500 border-radius-10 d-flex align-items-center justify-content-center text-start">
                                        {{ data.party }}
                                    </h6>
                                </template>
                                <template v-slot:inner-left-info>
                                    <h3 class="light-text extra-black-color font-weight-600">
                                        {{ `${(Number(data.attendance) - Number(data.rejected))?(Number(data.amount) / (Number(data.attendance) - Number(data.rejected)) *100).toFixed(2):0}%` }}
                                    </h3>
                                </template>
                                <template v-slot:inner-right-info>
                                    <h3 class="light-text font-weight-600 extra-black-color">{{ `${data.amount} ხმა` }}</h3>
                                </template>
                            </customProgressLine>
                        </li>
                    </template>
                </ul>
                <div v-if="modalMode == 'photo'" class="d-flex flex-column align-items-center gap-4">
                    <div class="image-wrapper w-100">
                        <button class="download-button" @click="downloadImage(photoURl, `${this.name}.jpg`)">
                            <img src="@/assets/images/download.svg" alt="download">
                        </button>
                        <img class="w-100 modal-photo" :src="photoURl" alt="img" style="max-height: 400px">
                    </div>
                </div>
            </div>
        </template>
    </primaryModalComponent>
</template>
<script>
import Multiselect from '@vueform/multiselect';
import customProgressLine from '@/components/customProgressLine.vue';
import primaryButtonComponent from '@/components/primaryButtonComponent.vue';
import ascDescBlock from '@/components/ascDescBlock.vue';
import primaryModalComponent from '@/components/primaryModalComponent.vue';
import commonCardAccordion from '@/components/commonCardAccordion.vue';
import secondaryButton from '@/components/secondaryButton.vue';
import excelFileDownloadComponent from '@/components/excelFileDownloadComponent.vue';
export default {
    data(){
        return {
            isSending: false,
            filteringPagingInfo: {
                finalTotalResultscityID: null,
                finalTotalResultsregionID: null,
                finalTotalResultsdistrictID: null,
                detailedFinalResultsdataName: null,
                detailedFinalResultsorderBy: null,
                detailedFinalResultsOffset: null,
                finalSingleResultscityID:null,
                finalSingleResultsregionID: null,
                finalSingleResultsdistrictID:null,
                finalSingleResultsseen: [],
                finalSingleResultsoffset: null,
                finalResultType: null,
                electionType: null,
            },
            activatedFilterMode: 3,
            // for top module>>
            electionTypeButtonsArray: [],
            finalResultTypeButtonsArray: [
                // {
                //     content: "აპარატით",
                //     routeSetValue: 1,
                //     mode: 0,
                // },
                // {
                //     content: "ოქმით",
                //     routeSetValue: 2,
                //     mode: 1,
                // },
            ],
            // for top left >>
            finalTotalResultsInformation: [],
            finalTotalResultsFiltersInfoObj: {
                cityID: null,
                regionID: null,
                districtID: null,
            },
            finalTotalResultsMultiselectsArray: [
                {
                    placeholder: "ოლქი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
            ],
            // for top right >>
            detailedFinalResultsInformation: [],
            detailedFinalResultsInformationForCapitalAndCountry: {},
            detailedFinalResultsCountedDistricts: 0,
            detailedFinalResultsFiltersInfoObj: {
                dataName: null,
                orderBy: null,
            },
            detailedFinalResultsPagingInfo: {
                offset: 1,
                limit: 10,
                total: 0,
            },
            detailedActivityJsonToExcelArray: [],
            detailedActivityDownloadInAction: false,
            detailedActivityAbortController: null,
            detailedFinalResultsInfoAllgetterButtonsArray: [
                {
                    content: "ქალაქი",
                    routeSetValue: "region",
                    mode: 0,
                },
                {
                    content: "უბანი",
                    routeSetValue: "district",
                    mode: 1,
                }
            ],
            detailedFinalResultsOrderByButtonsArray: [
                {
                    content: "ამომრჩევლების რაოდენობა",
                    routeSetValue: "attendance",
                    isActive: false,
                    activeMode: false,
                },
                {
                    content: "ამომრჩევლის რაოდენობის პროცენტი",
                    routeSetValue: "activityPercentage",
                    isActive: false,
                    activeMode: false,
                }
            ],
            // for modal >>
            showModal: false,
            modalTitle: "",
            modalMode: null,
            photoURl: null,
            name: null,
            // for finalSingleResults >>
            singleFinalResultsInformation: [],
            singleFinalResultsCountedDistricts: null,
            currentlySelectedDistrictsAttendance: null,
            currentlySelectedDistrictsRejected: null,
            electionPartiesResultsVmodels: {},
            currentlyOpenedSingleFinalResInformation: {},
            changedSingleFinalResultsObj: {},
            singleFinalResultsPagingInfo: {
                offset: 1,
                limit: 6,
                total: 0,
            },
            FinalSinglefiltersInfoObj: {
                cityID:null,
                regionID: null,
                districtID:null,
                checkBoxesArray: [],
            },
            singleFinalResultsDownloadInAction: false,
            singleFinalResultsJsonToExcelArray: [],
            singleFinalResultsAbortController: null,
            finalSingleMultiselectArray: [
                {
                    placeholder: "ოლქი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: false,
                },
                {
                    placeholder: "უბანი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
                {
                    placeholder: "უბნის ნომერი",
                    options: [],
                    Vmodel: null,
                    mode: "single",
                    isDisabled: true,
                },
            ],
            checkBoxesMultiselectArray: [
                {
                    placeholder: "დამატებითი ფილტრები",
                    options: [
                        {
                            sendName: "finalSingleResultsseen",
                            value: 3,
                            label: {
                                en: "seen",
                                ge: "ნანახი"
                            }
                        },
                    ],
                    Vmodel: null,
                    mode: "tags",
                    isDisabled: false,
                },  
            ],
            isAccordionOpened: false,
            indexOfOpenedAccordion: false,
            accordionCardCloseTrigger: false,
        }
    },
    components: {
        Multiselect,
        customProgressLine,
        primaryButtonComponent,
        ascDescBlock,
        primaryModalComponent,
        commonCardAccordion,
        secondaryButton,
        excelFileDownloadComponent,
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                this.manageFinalTotalResultsFilters();
            }else if(this.activatedFilterMode == 1){
                this.manageDetailedFinalResultsFilters();
            }else if(this.activatedFilterMode == 2){
                this.manageFinalSingleResultsFilters();
            }else if(this.activatedFilterMode == 3){
                this.manageResultsTypeFilters();
            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 3;
    },
    mounted(){
        this.removeAriaHidden();
        this.routerMountMovement(this.$route);
        // this.getCitiesAll([this.finalTotalResultsMultiselectsArray, this.finalSingleMultiselectArray]);
        this.$watch(() => this.finalTotalResultsMultiselectsArray[0].options, (newOptions, oldOptions) => {
                this.finalTotalResultsFiltersInfoObj.cityID = this.finalTotalResultsFiltersInfoObj.cityID;
                if(this.finalTotalResultsFiltersInfoObj.cityID){
                    this.allowNextMultiselect(this.finalTotalResultsFiltersInfoObj.cityID, 1, false, false, this.finalTotalResultsMultiselectsArray, this.finalTotalResultsFiltersInfoObj);
                    
                }
            },
            { deep: true }
        );
        this.$watch(() => this.finalTotalResultsMultiselectsArray[1].options, (newOptions, oldOptions) => {
                this.finalTotalResultsFiltersInfoObj.regionID = this.finalTotalResultsFiltersInfoObj.regionID;
                if(this.finalTotalResultsFiltersInfoObj.regionID){
                    this.allowNextMultiselect(this.finalTotalResultsFiltersInfoObj.regionID, 2, false, false, this.finalTotalResultsMultiselectsArray, this.finalTotalResultsFiltersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.finalTotalResultsMultiselectsArray[2].options, (newOptions, oldOptions) => {
                this.finalTotalResultsFiltersInfoObj.regionID = this.finalTotalResultsFiltersInfoObj.regionID;
            },
            { deep: true }
        );


        this.$watch(() => this.finalSingleMultiselectArray[0].options, (newOptions, oldOptions) => {
                this.FinalSinglefiltersInfoObj.cityID = this.FinalSinglefiltersInfoObj.cityID;
                if(this.FinalSinglefiltersInfoObj.cityID){
                    this.allowNextMultiselect(this.FinalSinglefiltersInfoObj.cityID, 1, false, false, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
                    
                }
            },
            { deep: true }
        );
        this.$watch(() => this.finalSingleMultiselectArray[1].options, (newOptions, oldOptions) => {
                this.FinalSinglefiltersInfoObj.regionID = this.FinalSinglefiltersInfoObj.regionID;
                if(this.FinalSinglefiltersInfoObj.regionID){
                    this.allowNextMultiselect(this.FinalSinglefiltersInfoObj.regionID, 2, false, false, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
                }
            },
            { deep: true }
        );
        this.$watch(() => this.finalSingleMultiselectArray[2].options, (newOptions, oldOptions) => {
                this.FinalSinglefiltersInfoObj.regionID = this.FinalSinglefiltersInfoObj.regionID;
            },
            { deep: true }
        );
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
            if(isQueriesValid){
                this.getResultTypes();
                this.getElectionTypes();
                this.getCitiesAll([this.finalTotalResultsMultiselectsArray, this.finalSingleMultiselectArray]);
                this.manageFinalTotalResultsFilters();
                this.manageDetailedFinalResultsFilters();
                this.manageFinalSingleResultsFilters();
            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 3;
        },
        async addChangesToSingleFinalResult(){
            let isCurrentlySelectedDistrictsAttendanceValid = this.$helper.checkNumber(this.currentlySelectedDistrictsAttendance);
            let isCurrentlySelectedDistrictsRejectedValid = this.$helper.checkNumber(this.currentlySelectedDistrictsRejected);
            let isCurrentlyChangedFinalResAmountsValid = Object.keys(this.changedSingleFinalResultsObj).every((resKey) => {
                return (this.$helper.checkNumber(this.changedSingleFinalResultsObj[resKey].amount));
            })
            let totalVmodels = 0;
            Object.keys(this.electionPartiesResultsVmodels).forEach((key) => {
                totalVmodels += this.electionPartiesResultsVmodels[key];
            })
            let isAmountBalanceValid = totalVmodels == (this.currentlySelectedDistrictsAttendance - this.currentlySelectedDistrictsRejected);
            let isEvidenceImageValid = this.$helper.checkJpeg(this.$refs.evidenceImage[0].files[0]);
            
            let isCurrentlySelectedDistrictsAttendanceChanged = (this.currentlySelectedDistrictsAttendance !== this.currentlyOpenedSingleFinalResInformation?.attendance);
            let isCurrentlySelectedDistrictsRejectedChanged = (this.currentlySelectedDistrictsRejected !== this.currentlyOpenedSingleFinalResInformation?.rejected);

            let isSomethingChanged = this.$refs.evidenceImage[0].files.length > 0 || isCurrentlySelectedDistrictsAttendanceChanged || isCurrentlySelectedDistrictsRejectedChanged || Object.keys(this.changedSingleFinalResultsObj).length > 0;
            // console.log(this.currentlySelectedDistrictsAttendance);
            // console.log(this.currentlyOpenedSingleFinalResInformation?.election_result[0]?.attendance);
            
            // console.log(isCurrentlySelectedDistrictsAttendanceChanged);
            // console.log(isCurrentlySelectedDistrictsRejectedChanged);
            // console.log(isSomethingChanged);
            // console.log(this.currentlySelectedDistrictsAttendance);
            // console.log(this.currentlySelectedDistrictsRejected);
            // console.log(isAmountBalanceValid);
            // console.log(totalVmodels);
            // console.log(this.currentlySelectedDistrictsAttendance);
            // console.log(this.currentlySelectedDistrictsRejected);
            // console.log(isEvidenceImageValid);
            
            



            if(isSomethingChanged && (isEvidenceImageValid && this.$refs.evidenceImage[0].files.length!=0) && isCurrentlySelectedDistrictsAttendanceValid && isCurrentlySelectedDistrictsRejectedValid && isCurrentlyChangedFinalResAmountsValid && isAmountBalanceValid){
                if(Object.keys(this.changedSingleFinalResultsObj).length == 0 && (isCurrentlySelectedDistrictsAttendanceChanged || isCurrentlySelectedDistrictsRejectedChanged)){ //&& this.$refs.evidenceImage[0].files.length == 0 do not need
                    this.currentlyOpenedSingleFinalResInformation.parties.forEach((party, index) => {
                        this.changedSingleFinalResultsObj[party.partyID] = {
                            partyID: party.partyID,
                            amount: party.election_result?.amount?party.election_result?.amount:0,
                            attendance: this.currentlySelectedDistrictsAttendance,
                            rejected: this.currentlySelectedDistrictsRejected,
                            districtID: this.currentlyOpenedSingleFinalResInformation.districtID,
                        };
                    })
                }else{
                    this.currentlyOpenedSingleFinalResInformation.parties.forEach((party, index) => {
                        if(this.changedSingleFinalResultsObj.hasOwnProperty(party.partyID)){
                            this.changedSingleFinalResultsObj[party.partyID].attendance = this.currentlySelectedDistrictsAttendance;
                            this.changedSingleFinalResultsObj[party.partyID].rejected = this.currentlySelectedDistrictsRejected;
                        }else{
                            this.changedSingleFinalResultsObj[party.partyID] = {
                                partyID: party.partyID,
                                amount: party.election_result?.amount?party.election_result?.amount:0,
                                attendance: this.currentlySelectedDistrictsAttendance,
                                rejected: this.currentlySelectedDistrictsRejected,
                                districtID: this.currentlyOpenedSingleFinalResInformation.districtID,
                            };
                        }
                    });
                }
                
                // Object.keys(this.changedSingleFinalResultsObj).forEach((key) => {
                //     this.changedSingleFinalResultsObj[key].attendance = this.currentlySelectedDistrictsAttendance;
                //     this.changedSingleFinalResultsObj[key].rejected = this.currentlySelectedDistrictsRejected;
                // })
                this.isSending = true;
                
                if(isCurrentlySelectedDistrictsAttendanceChanged || isCurrentlySelectedDistrictsRejectedChanged ||Object.keys(this.changedSingleFinalResultsObj).length > 0){
                    
                    await this.$store.dispatch("addElectionResultsFromAdmin", {changedSingleFinalResultsObj: this.changedSingleFinalResultsObj, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType}).then(async (response) => {
                        // if(response.status == 201){
                            
                        // }
                    }).catch((error) => {
                        this.$helper.showSwal("მოხდა შეცდომა ხმების ატვირთვისას", "error", "");
                        setTimeout(() => {this.$router.go()}, 1500);
                    })
                }

                if(isEvidenceImageValid && this.$refs.evidenceImage[0].files.length!=0){
                    let formData = new FormData();
                    formData.append("resultPhoto", this.$refs.evidenceImage[0].files["0"]);
                    formData.append("districtID", this.currentlyOpenedSingleFinalResInformation.districtID);
                    formData.append("result_typeID", this.filteringPagingInfo.electionType?this.filteringPagingInfo.electionType:1);
                    formData.append("election_typeID", this.filteringPagingInfo.electionType?this.filteringPagingInfo.electionType:1);

                    
                    await this.$store.dispatch("addElectionResultMedia", formData).then((response) => {
                        this.$helper.showSwal("შედეგები დაემატა", "success", "");
                        this.$refs.singleFinalResultsChangeForm[0].reset();
                        
                        this.currentlySelectedDistrictsAttendance = null;
                        this.currentlySelectedDistrictsRejected = null;
                        this.electionPartiesResultsVmodels = {};
                        this.currentlyOpenedSingleFinalResInformation = {};
                        this.changedSingleFinalResultsObj = {};
                        this.accordionCardCloseTrigger = !this.accordionCardCloseTrigger;
                        this.isAccordionOpened = false;
                        this.indexOfOpenedAccordion = null;
                        this.getElectionResults();
                        this.getElectionTotalResults();
                        this.activityDetails();

                    }).catch((error) => {
                        this.$helper.showSwal("მოხდა შეცდომა ფოტოს ატვირთვისას", "error", "");
                        setTimeout(() => {this.$router.go()}, 1500);

                    })
                }
                this.isSending = false;
            }else if(Object.keys(this.changedSingleFinalResultsObj).length == 0 && !isCurrentlySelectedDistrictsAttendanceChanged && !isCurrentlySelectedDistrictsRejectedChanged && this.$refs.evidenceImage[0].files.length==0){
                this.$helper.initializeSwalWithoutTimer("ცვლილებები არ მომხდარა", "error", "", true);
            }else if(Object.keys((this.changedSingleFinalResultsObj).length != 0 || isCurrentlySelectedDistrictsAttendanceChanged || isCurrentlySelectedDistrictsRejectedChanged) && this.$refs.evidenceImage[0].files.length==0){
                this.$helper.initializeSwalWithoutTimer("ცვლილებებისთვის აუცილებელია ფოტო მასალა", "error", "", true);
            }else if(!isAmountBalanceValid){
                this.$helper.initializeSwalWithoutTimer("ხმების არასწორი რაოდენობა", "error", "ხმების დასწრების და გაბათილებული ბილეთების არათანაბარი რაოდენობა", true);
            }else if(!isEvidenceImageValid && this.$refs.evidenceImage[0].files.length!=0){
                this.$helper.initializeSwalWithoutTimer("ფოტოს არასწორი ფორმატი", "error", "", true);
            }else{
                this.$helper.initializeSwalWithoutTimer("მოხდა შეცდომა", "error", "", true);
            }
        },
        setChangedPartyAmount(newVal, partyObj){
            // let existsChangedRes = this.currentlyOpenedSingleFinalResInformation.parties.find((localepartyObj) => {
            //     return (localepartyObj.partyID == partyObj.partyID);
            // })
            // console.log(existsChangedRes);
            // console.log(partyObj);
            
            let checkNumber = (partyObj?.election_result?.amount)?(partyObj.election_result.amount):0;
            
            if(checkNumber == newVal){
                delete this.changedSingleFinalResultsObj[partyObj.partyID];
            }else{
                this.changedSingleFinalResultsObj[partyObj.partyID] = {
                    partyID: partyObj.partyID,
                    amount: newVal,
                    districtID: this.currentlyOpenedSingleFinalResInformation.districtID,
                };
            }
        },
        downloadImage(base64URL, name){
            const link = document.createElement('a');
            link.href = base64URL;
            link.download = name;
            link.click();
            URL.revokeObjectURL(link);
        },
        setElectionPhoto(photoURL, name){
            this.photoURl = photoURL;
            this.name = name;
        },
        openAccordionOnIndex(index, attendance, rejected, itemItself){
            this.electionPartiesResultsVmodels = {};
            this.currentlyOpenedSingleFinalResInformation = {};
            this.changedSingleFinalResultsObj = {};

            

            if(attendance !== null && typeof(attendance) == "number"){
                this.currentlySelectedDistrictsAttendance = attendance;
                this.currentlySelectedDistrictsRejected = rejected;
            }else{
                this.currentlySelectedDistrictsAttendance = 0;
                this.currentlySelectedDistrictsRejected = 0;
            }
            
            itemItself.parties.forEach((partyObj) => {
                // if(resObj.partyID != 19){
                // }
                if(partyObj?.election_result?.amount){
                    this.electionPartiesResultsVmodels[partyObj.partyID] = partyObj.election_result.amount;
                }else{
                    this.electionPartiesResultsVmodels[partyObj.partyID] = 0;
                }
            })
            
            this.currentlyOpenedSingleFinalResInformation = {...itemItself};
            
            this.indexOfOpenedAccordion = index;
            this.isAccordionOpened = true;
        },
        closeAccordionOnIndex(index){
            this.$refs.singleFinalResultsChangeForm[0].reset();
            this.indexOfOpenedAccordion = null;
            this.isAccordionOpened = false;
            this.currentlySelectedDistrictsAttendance = null;
            this.currentlySelectedDistrictsRejected = null;
            this.electionPartiesResultsVmodels = {};
            this.currentlyOpenedSingleFinalResInformation = {};
            this.changedSingleFinalResultsObj = {};
        },
        getElectionResults(){
            let singleFinalResultsPagingOffset = this.filteringPagingInfo.finalSingleResultsoffset?Number(this.filteringPagingInfo.finalSingleResultsoffset):0;
            this.$store.dispatch("getElectionResults", {...this.FinalSinglefiltersInfoObj, offset: singleFinalResultsPagingOffset, limit: this.singleFinalResultsPagingInfo.limit, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType}).then((response) => {
                this.singleFinalResultsInformation = response.data[0];
                this.singleFinalResultsPagingInfo.total = response.data[1];
                this.singleFinalResultsCountedDistricts = response.data[2];
                this.accordionCardCloseTrigger = !this.accordionCardCloseTrigger;
                this.isAccordionOpened = false;
                this.indexOfOpenedAccordion = null;
            })
            
        },
        activityDetails(){
            let detailedFinalResultsPagingOffset = this.filteringPagingInfo.detailedFinalResultsOffset?Number(this.filteringPagingInfo.detailedFinalResultsOffset):0;
            this.$store.dispatch("activityDetails", {...this.detailedFinalResultsFiltersInfoObj, limit: this.detailedFinalResultsPagingInfo.limit, offset: detailedFinalResultsPagingOffset, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType}).then((response) => {
                this.detailedFinalResultsInformation = response.data[0];
                this.detailedFinalResultsPagingInfo.total = response.data[1];
                this.detailedFinalResultsCountedDistricts = response.data[2];
                this.detailedFinalResultsInformationForCapitalAndCountry = response.data[3];
            })
        },
        activateModalMode(modalMode, isOpen){
            if(modalMode == "finalTotalResultsFullList"){
                this.modalTitle = "სრული სია";
            }else if(modalMode == "photo"){
                this.modalTitle = "ფოტო მასალა";
            }
            this.modalMode = modalMode;
            this.triggerModal(isOpen);
        },
        triggerModal(isOpen){
            if(isOpen == false){
                this.modalTitle = "";
                this.photoURl = null;
                this.name = null;
            }
            this.showModal = isOpen;
        },
        getElectionTotalResults(){
            this.$store.dispatch('getElectionTotalResults', {...this.finalTotalResultsFiltersInfoObj, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType}).then((response) => {
                this.finalTotalResultsInformation = [];
                response.data.forEach((obj) => {
                    // if(obj.partyID != 19){
                    // }
                    this.finalTotalResultsInformation.push(obj);
                })
            })
        },
        resetFilters(){
            Object.keys(this.FinalSinglefiltersInfoObj).forEach((key) => {
                this.FinalSinglefiltersInfoObj[key] = null;
            })
            this.blockNextMultiselects(1, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
            this.submitFinalSingleResultsFilters();
        },
        manageFinalSingleResultsFilters(){
            
            Object.keys(this.FinalSinglefiltersInfoObj).forEach((key) => {
                if(Array.isArray(this.FinalSinglefiltersInfoObj[key])){
                    this.FinalSinglefiltersInfoObj[key] = [];
                
                    if(this.filteringPagingInfo.finalSingleResultsseen){
                        this.FinalSinglefiltersInfoObj[key].push({
                            ...this.checkBoxesMultiselectArray[0].options[0]
                        });
                    }
                }else{
                    if(this.filteringPagingInfo[`finalSingleResults${key}`]){
                        this.FinalSinglefiltersInfoObj[key] = Number(this.filteringPagingInfo[`finalSingleResults${key}`]);
                    }else{
                        this.FinalSinglefiltersInfoObj[key] = this.filteringPagingInfo[`finalSingleResults${key}`];
                    }
                }
            })
            this.singleFinalResultsPagingInfo.offset = this.filteringPagingInfo.finalSingleResultsoffset?(Number(this.filteringPagingInfo.finalSingleResultsoffset) + 1):1;
            
            if(!this.FinalSinglefiltersInfoObj.cityID){
                this.blockNextMultiselects(1, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
            }else if(!this.FinalSinglefiltersInfoObj.regionID){
                this.blockNextMultiselects(2, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
            }

            if(this.FinalSinglefiltersInfoObj.cityID){
                this.allowNextMultiselect(this.FinalSinglefiltersInfoObj.cityID, 1, false, false, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
            }else if(this.FinalSinglefiltersInfoObj.regionID){
                this.allowNextMultiselect(this.FinalSinglefiltersInfoObj.cityID, 2, false, false, this.finalSingleMultiselectArray, this.FinalSinglefiltersInfoObj);
            }



            this.getElectionResults();
        },
        submitFinalSingleResultsFilters(){
            let tempObj = {};
            if(this.$route.query.finalSingleResultsoffset){
                tempObj["finalSingleResultsoffset"] = 0;
            }
            Object.keys(this.FinalSinglefiltersInfoObj).forEach((key) => {
                if(Array.isArray(this.FinalSinglefiltersInfoObj[key])){
                    this.FinalSinglefiltersInfoObj[key].forEach((checkBoxObj) => {
                        tempObj[checkBoxObj.sendName] = true;
                    })
                }else{
                    if(this.FinalSinglefiltersInfoObj[key]){
                        tempObj[`finalSingleResults${key}`] = this.FinalSinglefiltersInfoObj[key];
                    }
                }
            })
            
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if((queryKey.startsWith("finalSingleResults") && this.FinalSinglefiltersInfoObj.hasOwnProperty(queryKey.slice(18))) || queryKey == "finalSingleResultsseen"){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.activatedFilterMode = 2;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        handleDetailedFinalResultsAscDesc(orderByButtonIndex){
            let sortSetString = "";
            this.detailedFinalResultsOrderByButtonsArray.forEach((orderByButton, index) => {
                if(orderByButtonIndex == index){
                    if(orderByButton.isActive){
                        orderByButton.activeMode = !orderByButton.activeMode;
                    }else{
                        orderByButton.isActive = true;
                        orderByButton.activeMode = false;
                    }
                    if(orderByButton.activeMode){
                        sortSetString = `${orderByButton.routeSetValue}:asc`;
                    }else{
                        sortSetString = `${orderByButton.routeSetValue}:desc`;
                    }
                }else{
                    orderByButton.isActive = false;
                    orderByButton.activeMode = false;
                }
            })
            
            this.activatedFilterMode = 1;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    detailedFinalResultsorderBy: sortSetString,
                    detailedFinalResultsOffset: 0,
                }
            });
        },
        manageDetailedFinalResultsFilters(){
            Object.keys(this.detailedFinalResultsFiltersInfoObj).forEach((key) => {
                if(key == "dataName"){
                    this.detailedFinalResultsFiltersInfoObj[key] = Number(this.filteringPagingInfo[`detailedFinalResults${key}`]);
                }else{
                    this.detailedFinalResultsFiltersInfoObj[key] = this.filteringPagingInfo[`detailedFinalResults${key}`]?this.filteringPagingInfo[`detailedFinalResults${key}`]:"attendance:desc";
                }
            })
            
            this.detailedFinalResultsInfoAllgetterButtonsArray.forEach((getterButtonObj, index) => {
                if(index == this.detailedFinalResultsFiltersInfoObj.dataName){
                    
                    getterButtonObj.mode = 0;
                }else{
                    getterButtonObj.mode = 1;
                }
            })
            this.detailedFinalResultsOrderByButtonsArray.forEach((orderByButton, index) => {
                if(this.detailedFinalResultsFiltersInfoObj.orderBy.startsWith(orderByButton.routeSetValue)){
                    orderByButton.isActive = true;
                    if(this.detailedFinalResultsFiltersInfoObj.orderBy.endsWith("asc")){
                        orderByButton.activeMode = true;
                    }else{
                        orderByButton.activeMode = false;
                    }
                }else{
                    orderByButton.isActive = false;
                    orderByButton.activeMode = false;
                }
            })
            this.detailedFinalResultsPagingInfo.offset = this.filteringPagingInfo.detailedFinalResultsOffset?(Number(this.filteringPagingInfo.detailedFinalResultsOffset) + 1):1;
            this.activityDetails();
        },
        getElectionTypes(){
            this.$store.dispatch("getElectionTypes").then((response) => {
                response.data.forEach((electionTypeObj, index) => {
                    this.electionTypeButtonsArray.push({
                        content: electionTypeObj.election_type,
                        routeSetValue: electionTypeObj.election_typeID,
                        mode: this.filteringPagingInfo.electionType?Number(this.filteringPagingInfo.electionType) == electionTypeObj.election_typeID?0:1:index == 0?0:1,
                    });
                });
                
            });
        },
        manageResultsTypeFilters(){
            this.finalResultTypeButtonsArray.forEach((resultObj, index) => {
                if(resultObj.routeSetValue == Number(this.filteringPagingInfo.finalResultType??1)){
                    resultObj.mode = 0;
                    
                }else{
                    resultObj.mode = 1;
                }
            })
            this.electionTypeButtonsArray.forEach((resultObj, index) => {
                if(resultObj.routeSetValue == Number(this.filteringPagingInfo.electionType??1)){
                    resultObj.mode = 0;
                    
                }else{
                    resultObj.mode = 1;
                }
            })
            this.manageFinalTotalResultsFilters();
            this.manageDetailedFinalResultsFilters();
            this.manageFinalSingleResultsFilters();
        },
        getResultTypes(){
            this.$store.dispatch("getResultTypes").then((response) => {
                
                response.data.forEach((resultObj, index) => {
                    this.finalResultTypeButtonsArray.push({
                        content: resultObj.result_type,
                        routeSetValue: resultObj.result_typeID,
                        mode: this.filteringPagingInfo.finalResultType?Number(this.filteringPagingInfo.finalResultType) == resultObj.result_typeID?0:1:index == 0?0:1,
                    });
                });
            })
        },
        finalResultTypeButtonsHandler(routeSetKeyWord, routeSetValue, iterationArray){
            let routeSetObj = {};
            routeSetObj[routeSetKeyWord] = routeSetValue;
            iterationArray.forEach((finalResTypeObj, index) => {
                if(routeSetValue == finalResTypeObj.routeSetValue){
                    this.activatedFilterMode = 3;
                    finalResTypeObj.mode = 0;
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            ...routeSetObj,
                            finalSingleResultsoffset: 0,
                            detailedFinalResultsOffset: 0,
                        },
                    });
                }else{
                    finalResTypeObj.mode = 1;
                }
            })
        },
        detailedFinalResultsGetterButtonsHandler(index){
            this.detailedFinalResultsInfoAllgetterButtonsArray.forEach((getterButtonObj, getterButtonIndex) => {
                if(getterButtonIndex == index){   
                    getterButtonObj.mode = 0;
                    this.activatedFilterMode = 1;
                    this.$router.push({
                        path: this.$route.path,
                        query: {
                            ...this.$route.query,
                            detailedFinalResultsdataName: getterButtonIndex, // 0, 1
                            detailedFinalResultsorderBy: "attendance:desc",
                            detailedFinalResultsOffset: 0,
                        },
                    });
                }else{
                    getterButtonObj.mode = 1;
                }
            })
        },
        manageFinalTotalResultsFilters(){
            Object.keys(this.finalTotalResultsFiltersInfoObj).forEach((key) => {
                if(this.filteringPagingInfo[`finalTotalResults${key}`]){
                    this.finalTotalResultsFiltersInfoObj[key] = Number(this.filteringPagingInfo[`finalTotalResults${key}`]);
                }else{
                    this.finalTotalResultsFiltersInfoObj[key] = this.filteringPagingInfo[`finalTotalResults${key}`];
                }
            })
            if(!this.finalTotalResultsFiltersInfoObj.cityID){
                this.blockNextMultiselects(1, this.finalTotalResultsMultiselectsArray, this.finalTotalResultsFiltersInfoObj);
            }else if(!this.finalTotalResultsFiltersInfoObj.regionID){
                this.blockNextMultiselects(2, this.finalTotalResultsMultiselectsArray, this.finalTotalResultsFiltersInfoObj);
            }

            if(this.finalTotalResultsFiltersInfoObj.cityID){
                this.allowNextMultiselect(this.finalTotalResultsFiltersInfoObj.cityID, 1, false, false, this.finalTotalResultsMultiselectsArray, this.finalTotalResultsFiltersInfoObj);
            }else if(this.finalTotalResultsFiltersInfoObj.regionID){
                this.allowNextMultiselect(this.finalTotalResultsFiltersInfoObj.cityID, 2, false, false, this.finalTotalResultsMultiselectsArray, this.finalTotalResultsFiltersInfoObj);
            }
            this.getElectionTotalResults();
        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = null;
                if(key == "finalSingleResultsseen"){
                    this.filteringPagingInfo[key] = to.query[key]?1:0;
                }else if(key == "finalResultType" || key == "electionType"){
                    this.filteringPagingInfo[key] = to.query[key]??1;
                }else{
                    this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
                }
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(this.filteringPagingInfo[key] == null){
                    return true;
                }else if(key == "detailedFinalResultsorderBy"){
                    if(this.filteringPagingInfo[key] == "attendance:desc" || this.filteringPagingInfo[key] == "attendance:asc" 
                        || this.filteringPagingInfo[key] == "activityPercentage:desc" || this.filteringPagingInfo[key] == "activityPercentage:asc"){
                        return true;
                    }else {
                        return false;
                    }
                }else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            })
            
            return isQueriesValid;
        },
        submitTotalFinalResults(){
            let tempObj = {};
            Object.keys(this.finalTotalResultsFiltersInfoObj).forEach((key) => {
                if(this.finalTotalResultsFiltersInfoObj[key]){
                    tempObj[`finalTotalResults${key}`] = this.finalTotalResultsFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 0;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.finalTotalResultsFiltersInfoObj.hasOwnProperty(`${queryKey.slice(17)}`) && queryKey.startsWith("finalTotalResults")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })

            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        allowNextMultiselect(value, index, clear, blockNext, changingArray, filterVModelsArray){
            if(value){
                if(index == 0){
                    this.getCities(value, clear, changingArray, filterVModelsArray);
                }else if(index == 1){
                    this.getRegions(value, clear, changingArray, filterVModelsArray);
                }else if(index == 2){
                    this.getDistricts(value, clear, changingArray, filterVModelsArray);
                }
            }
            if(index < changingArray.length - 1 && blockNext){
                this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
            }
        },
        blockNextMultiselects(index, changingArray, filterVModelsArray){
            
            if(index >= changingArray.length){
                return;
            }
            changingArray[index].options = [];
            if(index == 0){
                filterVModelsArray.cityID = null;
            }else if(index == 1){
                filterVModelsArray.regionID = null;
            changingArray[index].isDisabled = true;
            }else if(index == 2){
                filterVModelsArray.districtID = null;
                changingArray[index].isDisabled = true;
            }
            this.blockNextMultiselects(index + 1, changingArray, filterVModelsArray);
        },
        removeAriaHidden(){
            Array.from(document.querySelectorAll('.multiselect span[aria-hidden]')).forEach((item) => {
                item.removeAttribute('aria-hidden');
            })
        },
        getCitiesAll(changingArray){
            this.$store.dispatch("getCitiesAll").then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: `${obj.city} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.cityeng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                changingArray.forEach((destArray) => {
                    destArray[0].options = tempArray;
                    destArray[0].isDisabled = false;
                })
                // changingArray[1].options = tempArray;
                // changingArray[1].isDisabled = false;
            })
        },
        getCities(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getCities",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.cityID,
                        label: {
                            ge: obj.city,
                            en: obj.cityeng,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.cityID = null;
                }
                changingArray[0].options = tempArray;
                changingArray[0].isDisabled = false;
            })
        },
        getRegions(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getRegions",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.regionID,
                        label: {
                            ge: `${obj.region} ${obj.pathID?`- ${obj.pathID}`:""}`,
                            en: `${obj.regioneng} ${obj.pathID?`- ${obj.pathID}`:""}`,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.regionID = null;
                }
                changingArray[1].options = tempArray;
                changingArray[1].isDisabled = false;
            })
        },
        getDistricts(valueID, clear, changingArray, filterVModelsArray){
            this.$store.dispatch("getDistricts",valueID).then((response) => {
                let tempArray = [];
                for(let obj of response.data){
                    tempArray.push({
                        value: obj.districtID,
                        label: {
                            ge: obj.district,
                            en: obj.district,
                        },
                    });
                }
                if(clear){
                    filterVModelsArray.districtID = null;
                }
                changingArray[2].options = tempArray;
                changingArray[2].isDisabled = false;
            })
        },
        async detailedActivityDownloadIgnition(){
            let firstArray = [];
            let secondArray = [];
            this.detailedActivityJsonToExcelArray = [];
            this.isSending = true;
            this.detailedActivityAbortController = new AbortController();


            await Promise.all([
                this.$store.dispatch("activityDetails", {...this.detailedFinalResultsFiltersInfoObj, limit: Number.MAX_SAFE_INTEGER, offset: 0, dataName: 0, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType, signal: this?.detailedActivityAbortController?.signal}),
                this.$store.dispatch("activityDetails", {...this.detailedFinalResultsFiltersInfoObj, limit: Number.MAX_SAFE_INTEGER, offset: 0, dataName: 1, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType, signal: this?.detailedActivityAbortController?.signal})
            ]).then((response) => {

                firstArray.push([
                    "რეგიონი",
                    "ამომრჩევლების რაოდენობა",
                    "ამომრჩევლების რაოდენობის პროცენტი"
                ]);
                response[0].data[0].forEach((obj) => {
                    firstArray.push([
                        obj.region,
                        `${obj.attendance}/${obj.sum_count}`,
                        `${obj.activityPercentage}%`,
                    ]);
                })

                secondArray.push([
                    "უბანი",
                    "ამომრჩევლების რაოდენობა",
                    "ამომრჩევლების რაოდენობის პროცენტი"
                ]);
                response[1].data[0].forEach((obj) => {
                    secondArray.push([
                        obj.district,
                        `${obj.attendance}/${obj.sum_count}`,
                        `${obj.activityPercentage}%`,
                    ]);
                })
                
                this.detailedActivityJsonToExcelArray.push(firstArray);
                this.detailedActivityJsonToExcelArray.push(secondArray);
                this.detailedActivityDownloadInAction = !this.detailedActivityDownloadInAction;
                this.isSending = false;
                this.detailedActivityAbortController = null;
            }).catch((error) => {
            }).finally(() => {
                this.isSending = false;
                this.detailedActivityAbortController = null;
            })


        },
        detailedActivityAbortDownload(){
            
            this?.detailedActivityAbortController?.abort();
            this.detailedActivityAbortController = null;
            
        },
        singleFinalResultsDownloadIgnition(){
            let firstArray = [];
            this.singleFinalResultsJsonToExcelArray = [];
            this.isSending = true;
            this.singleFinalResultsAbortController = new AbortController();

            this.$store.dispatch("getElectionResults", {...this.FinalSinglefiltersInfoObj, offset: 0, limit: Number.MAX_SAFE_INTEGER, result_typeID: this.filteringPagingInfo.finalResultType, election_typeID: this.filteringPagingInfo.electionType, signal: this.singleFinalResultsAbortController.signal}).then((response) => {
                firstArray.push([
                    'რეგიონი',
                    'უბანი',
                    'დრო',
                    'დასწრება',
                    'გაბათილებული',
                    'ფოტო',
                ]);

                response.data[0].forEach((districtObj, index) => {
                    firstArray.push([
                        districtObj?.region?.region,
                        districtObj?.district,
                        districtObj?.parties[0]?.election_result?.input_date,
                        districtObj?.attendance,
                        districtObj?.rejected,
                        districtObj?.media_files?.length > 0?"კი":"არა"
                    ]);
                })
                
                this.singleFinalResultsJsonToExcelArray.push(firstArray);
                this.singleFinalResultsDownloadInAction = !this.singleFinalResultsDownloadInAction;
                this.singleFinalResultsAbortController = null;
                this.isSending = false;
                
            }).catch(() => {
            }).finally(() => {
                this.singleFinalResultsAbortController = null;
                this.isSending = false;
            })
        },
        singleFinalResultsAbortDownload(){
            
            this?.singleFinalResultsAbortController?.abort();

            this.singleFinalResultsAbortController = null;
        },
        finalResultsPaginationClickHandler(value){
            this.activatedFilterMode = 1;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    detailedFinalResultsOffset: encodeURIComponent(value - 1),
                }
            });
        },
        singlefinalResultsPaginationClickHandler(value){
            this.activatedFilterMode = 2;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    finalSingleResultsoffset: encodeURIComponent(value - 1),
                }
            });
        },
    },
}
</script>
<style scoped>
.home-container{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, min-content);
    row-gap: .5em;
    overflow: hidden;
}
.final-results-common-statistics-wrapper{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    gap: 0.7em;
    margin-bottom: 1rem;
}
.final-results-total-statistics-wrapper, .final-results-detailed-statistics-wrapper{
    background-color: var(--secondary-background-color);
}
.final-results-total-filters-wrapper .multiselect{
    max-width: 160px;
    margin: 0;
}
.common-table-container :is(td, th), .election-cards-and-table-wrapper .common-table-container :is(td, th){
    padding: 5px 5px;
}
.common-table-container th, .election-cards-and-table-wrapper .common-table-container th{
    white-space: wrap;
    text-overflow: ellipsis;
}
.common-table-container tr :is(th:nth-child(1), td:nth-child(1)) , .election-cards-and-table-wrapper .common-table-container tr :is(th:nth-child(1), td:nth-child(1)){
    text-align: start;
}
.final-idle-results{
    background-color: var(--secondary-background-color);
}
.filters-wrapper{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;
    gap: 15px;
}
.filters-wrapper .multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
.single-final-results-parties-grid-wrapper{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: min-content;
    gap: 1.5em;
}
.problem-images-wrapper img,.problem-images-wrapper .image-alternative{
    height: 50px;
    aspect-ratio: 1 / 1;
    object-fit: contain;
}
.image-wrapper{
    position: relative;
    max-width: 600px;
}
.image-wrapper .download-button{
    position: absolute;
    padding: 5px;
    background-color: #ffffffd1;
    border-radius: 7px;
    right: 3px;
    top: 3px;
}
.party-name{
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
@media screen and (max-width: 1900px) {
    .image-wrapper{
        max-width: 500px;
    }
}

@media screen and (max-width: 1800px) {
    .filters-wrapper .multiselect{
        max-width: 200px;
    }
    .image-wrapper{
        max-width: 400px;
    }
}

@media screen and (max-width: 1310px) {
    .search-container-form .filters-wrapper .multiselect{
        min-width: 130px;
    }
}
</style>